var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.4@core-js/library/modules/_has.js
// module id = U5Wv
// module chunks = 0